import { Swiper, SwiperSlide } from 'swiper-cjs/react';
import '../../scss/pages/_reviews.scss';
import { Lazy, Navigation, Pagination } from 'swiper-cjs';
import _ from 'lodash';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Reviews = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const reviewsSliderItemsVK = _.times(8).map(item => (
    <SwiperSlide className={`reviews-slider-item`} key={item}>
      <img src={`https://trustunboxing.com/cscase/reviews/vk-${item}.png`} />
    </SwiperSlide>
  ));
  const reviewsSliderItemsTrust = _.times(12).map(item => (
    <SwiperSlide className={`reviews-slider-item`} key={item}>
      <img src={`https://trustunboxing.com/cscase/reviews/trust-${item}.png`} />
    </SwiperSlide>
  ));
  const reviewsSliderItemsVideo = [
    'kWvbbbp84uw',
    'uXxa20fdOKE',
    'ZMD1Re0j1k0',
    'NboLti3GqiQ',
  ].map(item => (
    <SwiperSlide className={`reviews-slider-item`} key={item}>
      <iframe
        width="425"
        height="240"
        src={`https://www.youtube.com/embed/${item}`}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </SwiperSlide>
  ));

  return (
    <div className="page-reviews">
      <h1>{t('CSCASE Reviews')}</h1>
      <div className="page-reviews-wrapper">
        <nav className="reviews-menu">
          <ul>
            <li
              className={`${
                _.includes(location.pathname, '/video') && 'active'
              }`}
            >
              <Link to="/reviews/video">{t('Video reviews')}</Link>
            </li>
            <li
              className={`${
                _.includes(location.pathname, '/trustpilot') && 'active'
              }`}
            >
              <Link to="/reviews/trustpilot">Trustpilot</Link>
            </li>
            <li
              className={`${_.includes(location.pathname, '/vk') && 'active'}`}
            >
              <Link to="/reviews/vk">{t('Discussions vk')}</Link>
            </li>
          </ul>
        </nav>
        <div className="reviews-slider-wrap">
          <Swiper
            className="reviews-slider reviews-slider-card"
            direction="horizontal"
            modules={[Navigation, Pagination, Lazy]}
            slidesPerView="auto"
            lazy={{ loadPrevNext: true, loadPrevNextAmount: 2 }}
            loop
            centeredSlides
            initialSlide={0}
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }}
            breakpoints={{
              '320px': {
                slidesPerView: 3,
                spaceBetween: 10,
                centeredSlides: true,
              },
              '992px': {
                slidesPerView: 'auto',
              },
            }}
            pagination={{
              el: '.swiper-pagination',
              type: 'fraction',
            }}
          >
            <div className="swiper-wrapper">
              {_.includes(location.pathname, '/video')
                ? reviewsSliderItemsVideo
                : _.includes(location.pathname, '/vk')
                ? reviewsSliderItemsVK
                : reviewsSliderItemsTrust}
            </div>
            <div className="swiper-button-prev" />
            <div className="swiper-button-next" />
            <div className="swiper-pagination swiper-pagination-fraction" />
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
